<app-common-header
  [isAdminOrTutor]="role === '1' || role === '2'"
></app-common-header>
<div class="body">
  <div class="mainContent">
    <div class="classes">
      <span class="classes__heading">Batch List</span>
      <div class="classes__filterSection" *ngIf="role === '1'">
        <button class="createTopic" [routerLink]="['/create-class']">
          <!--replace with /create-batch for Batch component -->
          <mat-icon>add</mat-icon>Create Batch
        </button>
        <div class="classes__filterSection__searchSection">
          <span class="classes__filterSection__searchSection__label"
            >Search</span
          >
          <input
            class="classes__filterSection__searchSection__searchInput"
            [(ngModel)]="searchTable"
            (keyup)="applyFilter()"
          /><button
            class="classes__filterSection__searchSection__searchButton button"
          >
            <mat-icon>search</mat-icon>
          </button>
        </div>
        <div class="classes__filterSection__selectTest">
          <span class="classes__filterSection__selectTest__label">Batch</span>
          <!-- <select class="classes__filterSection__selectTest__select">
            <option hidden selected>Select</option>
          </select> -->
          <mat-select
            class="classes__filterSection__selectTest__select"
            [(value)]="selectedBatchType"
            (selectionChange)="getSelectedBatches()"
          >
            <mat-option [value]="1">Active</mat-option>
            <mat-option [value]="2">Inactive</mat-option>
            <mat-option [value]="3">All</mat-option>
          </mat-select>
        </div>
      </div>
      <table mat-table [dataSource]="classes" class="classes__table">
        <ng-container matColumnDef="batch_name">
          <th mat-header-cell *matHeaderCellDef>Batch Name</th>
          <td mat-cell *matCellDef="let class" class="capitalize">
            {{ class["batchName"] }}
          </td>
        </ng-container>
        <ng-container matColumnDef="course">
          <th mat-header-cell *matHeaderCellDef>Course</th>
          <td mat-cell *matCellDef="let class" class="capitalize">
            <ng-container
              *ngFor="let course of class['courses']; index as courseIndex"
              >{{
                course["courseName"] +
                  (courseIndex === class["courses"]["length"] - 1 ? "" : ", ")
              }}</ng-container
            >
          </td>
        </ng-container>
        <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef>Start Date</th>
          <td mat-cell *matCellDef="let class" class="capitalize">
            {{ convertDate(class["startDate"]) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="schedule">
          <th mat-header-cell *matHeaderCellDef>Schedule</th>
          <td mat-cell *matCellDef="let class" class="capitalize">
            <app-info-popup
              *ngIf="true"
              [className]="'smallPopover'"
              [innerContent]="class['schedules']"
              [text]="'View'"
            ></app-info-popup>
          </td>
        </ng-container>
        <ng-container matColumnDef="students">
          <th mat-header-cell *matHeaderCellDef>Students</th>
          <td mat-cell *matCellDef="let class" class="capitalize">
            <app-info-popup
              *ngIf="true"
              [className]="''"
              [innerContent]="class['students']"
              [text]="class['students']['length']"
              [students]="'true'"
            ></app-info-popup>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let class" class="capitalize">
            <button
              class="button classes__table__edit"
              [routerLink]="['/edit-class', class['batchId']]"
            >
              Edit
            </button>
            <!-- replace with edit-batch for batch component -->
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
      </table>
      <mat-paginator
        [pageSize]="15"
        showFirstLastButtons
        #paginator
      ></mat-paginator>
    </div>
    <app-footer></app-footer>
  </div>
</div>
